import type { LetterSignature } from '../types';

/**
 * Renders a stored signature path. Inherits the letter's ink color via
 * currentColor, so it tints to whatever paper theme is in use. Capped to
 * a sensible display size; the SVG scales the path to fit.
 */
export function LetterSignatureView({ signature }: { signature: LetterSignature }) {
  return (
    <svg
      className="letter-signature"
      viewBox={`0 0 ${signature.w} ${signature.h}`}
      preserveAspectRatio="xMaxYMid meet"
      role="img"
      aria-label="signature"
    >
      <path
        d={signature.d}
        fill="none"
        stroke="currentColor"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
